export const SUPPORTED_LANGUAGES = ["pt-BR", "en", "es"] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = "pt-BR"

/** Chave do localStorage: só é gravada quando o usuário escolhe o idioma no seletor. */
export const LANGUAGE_STORAGE_KEY = "celetus.checkout.lang"

/** Parâmetro de URL que força o idioma (ex.: ?lang=en). */
export const LANGUAGE_QUERY_PARAM = "lang"

/**
 * Converte um locale BCP-47 (navigator.language, ?lang=) no idioma suportado correspondente.
 * Mantém a regra de negócio do detectLocale do telefone: qualquer variante pt-* (inclusive
 * pt-PT) vira pt-BR, porque navegadores brasileiros configurados em pt-PT são o caso comum
 * nesta plataforma. Retorna o valor original quando o idioma não é suportado, para o
 * i18next seguir para o próximo candidato (ou para o fallback pt-BR).
 */
export const normalizeLanguage = (locale: string): string => {
  const base = locale.trim().toLowerCase().split(/[-_]/)[0]

  if (base === "pt") return "pt-BR"
  if (base === "en") return "en"
  if (base === "es") return "es"

  return locale
}
